import { render, staticRenderFns } from "./TargetCompany.vue?vue&type=template&id=2c94e731"
import script from "./TargetCompany.vue?vue&type=script&lang=js"
export * from "./TargetCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports